import axios, { AxiosPromise } from 'axios';

type SafeResult = {
    error? : string;
    data? : any;
}

export default class Service {

    private static BASE_URL = `${process.env.REACT_APP_RESOURCE_SERVER}/payments`;

    private static _createSafeResponse = async (promise : AxiosPromise<object>) : Promise<SafeResult> => {
        try {
            const response = await promise;

            if (response && response.data) {
                return { error : undefined, data : response.data };
            }

            return { error : 'Could not get any data back from the server', data : undefined };
        } catch (error) {
            return { error, data : undefined };
        }
    }

    static createPaymentIntentForAmount = (amount : number, oneShot: any) => {
        const promise = axios.post(`${Service.BASE_URL}`, { 
            amount, 
            oneShot,
            currency : 'eur' 
        });

        return Service._createSafeResponse(promise);
    }
}